import { useLocation } from "react-router-dom";
import T, { GetLang } from "./translations/Translations";

import "@/styles/loadingSvg2.scss";

const LoadingSvg2 = (): JSX.Element => {
    const location = useLocation();
    const lang = GetLang();
    return (
        <div className="loading-overlay loading-center">
            <div className="svg-background">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
            </div>
            {!location.pathname.includes("open-enrollment") && (
                <div className="loading-text">{T({ tKey: "Global_Loading", langStr: lang })}</div>
            )}
        </div>
    );
};

export default LoadingSvg2;
